import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EmployeeService } from 'src/app/services/employee.service';
import { FixedPanelService } from 'src/app/services/fixed-panel.service';
import { Global } from '../../../common/global';
import { DataService } from '../../../services/api/data.service';
import { StaticDataService } from '../../../services/api/static-data.service';
import { SessionService } from '../../../services/session/session.service';
import { SettingService } from '../../../services/setting.service';
import { SalaryRecordItemHelper } from './controls/salary-record-item-helper';
import { PayrollCommon } from './payroll-common';
var EmployeePayrollDataMobileComponent = /** @class */ (function () {
    function EmployeePayrollDataMobileComponent(translateService, dataService, settingService, sessionService, fixedPanelService, renderer, staticDataService, employeeService) {
        this.translateService = translateService;
        this.dataService = dataService;
        this.settingService = settingService;
        this.sessionService = sessionService;
        this.fixedPanelService = fixedPanelService;
        this.renderer = renderer;
        this.staticDataService = staticDataService;
        this.employeeService = employeeService;
        this.currentAddnew = false;
        this.currentUpdate = false;
        this.isAddNewChange = new EventEmitter();
        this.DimensionXValue = [];
        this.showSelectPeriodDialog = false;
        this.recalculate = false;
        this.showInsertOrUpdatesalaryRecords = false;
        this.salaryRecordModel = {};
        this.flagUpdate = false;
        this.showNegativeDefaulChange = false;
        this.classShowSelectPeriodDialog = '';
        this.classoverlayScreen = '';
        this.isShowButtonPreview = true;
        this.confirmDeleteDialogVisible = false;
        this.isReloadBytype = false;
        this.ngUnsubscribe = new Subject();
        this.isHaveNavigate = false;
        this.isValidModel = true;
        this.negativeDefaultMoreDialogModel = {};
    }
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "userEmployment", {
        get: function () {
            return this.userEmploymentValue;
        },
        set: function (value) {
            if (this.userEmploymentValue !== value) {
                this.userEmploymentValue = value;
                if (value && value.Id) {
                    this.loadSalaryTypes();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isAddNew", {
        get: function () {
            return this.currentAddnew;
        },
        set: function (value) {
            this.currentAddnew = value;
            this.isAddNewChange.emit(value);
            if (value) {
                this.onOpenCreateDialog();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isUpdate", {
        get: function () {
            return this.currentUpdate;
        },
        set: function (value) {
            this.currentUpdate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "Dimension1Preference", {
        get: function () {
            return Global.COMPANY_PREFERENCES
                ? Global.COMPANY_PREFERENCES.find(function (pref) { return pref.Key === 'Dimensions.Dimension1Name'; })
                : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "Dimension2Preference", {
        get: function () {
            return Global.COMPANY_PREFERENCES
                ? Global.COMPANY_PREFERENCES.find(function (pref) { return pref.Key === 'Dimensions.Dimension2Name'; })
                : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "Dimension3Preference", {
        get: function () {
            return Global.COMPANY_PREFERENCES
                ? Global.COMPANY_PREFERENCES.find(function (pref) { return pref.Key === 'Dimensions.Dimension3Name'; })
                : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isEnableDimensionPreference", {
        get: function () {
            var pref = this.sessionService.getCompanyPreference('Dimension.UseDimensionValueEntities');
            return pref.Value === 'true' ? true : false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isHasEmployeeTotal", {
        get: function () {
            if (this.totalButtonPreviewText) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "IsEnableDateAdjustment", {
        get: function () {
            var enableDateAdjustment = PayrollCommon.getLocalStorageEnableDatePreferenceSetting();
            if (!enableDateAdjustment) {
                enableDateAdjustment = PayrollCommon.createLocalStorageEnableDatePreferenceSetting(false);
            }
            var value = enableDateAdjustment.Value.toLowerCase();
            return value === 'true';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isHaveDateValuesInDataSource", {
        get: function () {
            if (this.salaryRecords &&
                this.salaryRecords.length > 0 &&
                (this.salaryRecords.some(function (model) { return !!model.StartDate; }) ||
                    this.salaryRecords.some(function (model) { return !!model.EndDate; }))) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    EmployeePayrollDataMobileComponent.prototype.runEnableDateAdjustmentsRules = function () {
        var enableDateAdjustment = this.IsEnableDateAdjustment;
        this.showDateColumns(enableDateAdjustment);
    };
    EmployeePayrollDataMobileComponent.prototype.showDateColumns = function (show) {
        this.isHideDateColumns = !show;
        if (this.isHaveDateValuesInDataSource) {
            this.isHideDateColumns = false;
        }
    };
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "NumericOptions", {
        get: function () {
            if (this.numericOptions) {
                return this.numericOptions;
            }
            return (this.numericOptions = {
                format: 'n2',
                decimals: 2,
                step: 1,
                min: null,
                spinners: false
            });
        },
        enumerable: true,
        configurable: true
    });
    EmployeePayrollDataMobileComponent.prototype.translateText = function () {
        var _this = this;
        this.translateService
            .get(['EmploymentPayrollData.PerUnit', 'EmploymentPayrollData.Amount', 'EmploymentPayrollData.Units'])
            .subscribe(function (translations) {
            _this.perunitsText = translations['EmploymentPayrollData.PerUnit'];
            _this.amountText = translations['EmploymentPayrollData.Amount'];
            _this.unitText = translations['EmploymentPayrollData.Units'];
        });
    };
    EmployeePayrollDataMobileComponent.prototype.loadSalaryTypes = function () {
        var _this = this;
        this.salaryRecords = [];
        this.salaryTypes = [];
        this.disableGridToolbar = true;
        this.dataService.SalaryTypes_GetSalaryTypeViews().subscribe(function (salaryTypes) {
            if (_this.userEmploymentValue.IncomeTypeId === 5) {
                _this.salaryTypes = salaryTypes.filter(function (salaryType) { return salaryType.IsVisible && salaryType.RelatesToIncomeType5 !== false; });
            }
            else {
                _this.salaryTypes = salaryTypes.filter(function (salaryType) { return salaryType.IsVisible && !salaryType.RelatesToIncomeType5; });
            }
            _this.loadSalaryRecords();
        });
        this.updateDimensionValue();
    };
    EmployeePayrollDataMobileComponent.prototype.updateDimensionValue = function () {
        if (this.Dimension1Preference && this.Dimension1Preference.Value) {
            this.updateDimensionXValues(1);
        }
        if (this.Dimension2Preference && this.Dimension2Preference.Value) {
            this.updateDimensionXValues(2);
        }
        if (this.Dimension3Preference && this.Dimension3Preference.Value) {
            this.updateDimensionXValues(3);
        }
    };
    EmployeePayrollDataMobileComponent.prototype.updateDimensionXValues = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var employment_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isEnableDimensionPreference) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.employeeService.employment.subscribe(function (data) {
                                employment_1 = data;
                            })];
                    case 1:
                        _a.sent();
                        this.dataService.DimensionValues_GetDimensionValues(index).subscribe(function (data) {
                            _this.DimensionXValue[index - 1] = data.filter(function (value) {
                                if (!value.LimitToDepartmentId && !value.LimitToTemplateId) {
                                    return true;
                                }
                                else if (!value.LimitToDepartmentId) {
                                    if (employment_1.BasedOnTemplateId === value.LimitToTemplateId) {
                                        return true;
                                    }
                                    return false;
                                }
                                else if (!value.LimitToTemplateId) {
                                    if (employment_1.DepartmentId === value.LimitToDepartmentId) {
                                        return true;
                                    }
                                    return false;
                                }
                                else if (value.LimitToDepartmentId && value.LimitToTemplateId) {
                                    if (employment_1.DepartmentId === value.LimitToDepartmentId &&
                                        employment_1.BasedOnTemplateId === value.LimitToTemplateId) {
                                        return true;
                                    }
                                    return false;
                                }
                                return false;
                            });
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        this.dataService.Miscellaneous_GetDimensionValues(index).subscribe(function (data) {
                            _this.DimensionXValue[index - 1] = data.filter(function (value) { return value; });
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    EmployeePayrollDataMobileComponent.prototype.loadSalaryRecords = function () {
        var _this = this;
        if (!this.userEmployment) {
            return;
        }
        this.dataService
            .SalaryRecords_GetSalaryRecordsByEmployment(this.userEmployment.Id)
            .subscribe(function (salaryRecords) {
            _this.salaryRecords = salaryRecords;
            _this.disableGridToolbar = false;
            _this.translateText();
        });
    };
    EmployeePayrollDataMobileComponent.prototype.getNameByTypeId = function (typeId) {
        if (this.salaryTypes && this.salaryTypes.length > 0) {
            var typeObject = this.salaryTypes.find(function (z) { return z.SalaryTypeId === typeId; });
            if (typeObject && typeObject.Name) {
                return typeObject.Name;
            }
        }
        return '';
    };
    EmployeePayrollDataMobileComponent.prototype.convertDateToString = function (dateconvert) {
        if (dateconvert) {
            var currentdate = new Date(dateconvert);
            return this.sessionService.toString(currentdate);
        }
        return '';
    };
    EmployeePayrollDataMobileComponent.prototype.getStringStartDateAndEnddate = function (startdate, enddate) {
        if (startdate && enddate) {
            return this.convertDateToString(startdate) + ' - ' + this.convertDateToString(enddate);
        }
        return '';
    };
    EmployeePayrollDataMobileComponent.prototype.getUnitAndType = function (model) {
        if (this.unitTypes && this.unitTypes.length > 0 && model) {
            var unitObject = this.unitTypes.find(function (z) { return z.Id === model.UnitTypeId; });
            if (unitObject) {
                if (unitObject.Key === 'Percent') {
                    return model.BaseAmount ? this.formatunit(model.BaseAmount.toString()) + ' ' + unitObject.Name : '';
                }
                else {
                    return model.Units ? this.formatunit(model.Units.toString()) + ' ' + unitObject.Name : '';
                }
            }
        }
        return model && model.Units ? this.formatunit(model.Units.toString()) : '';
    };
    EmployeePayrollDataMobileComponent.prototype.getPerunit = function (model) {
        if (model) {
            if (this.unitTypes && this.unitTypes.length > 0) {
                var unitObject = this.unitTypes.find(function (z) { return z.Id === model.UnitTypeId; });
                if (unitObject) {
                    if (unitObject.Key === 'Percent') {
                        return model.Units ? this.formatunit(model.Units.toString()) + ' ' + this.unitText : '';
                    }
                    else {
                        return model.AmountPerUnit ? this.formatunit(model.AmountPerUnit.toString()) + ' ' + this.perunitsText : '';
                    }
                }
            }
            return model.AmountPerUnit ? this.formatunit(model.AmountPerUnit.toString()) + ' ' + this.perunitsText : '';
        }
        return '';
    };
    EmployeePayrollDataMobileComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EmployeePayrollDataMobileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.unitTypes = Global.UNIT_TYPES;
        this.staticDataService.SalaryRecordPersistenceType.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            _this.persistanceTypes = data;
        });
    };
    EmployeePayrollDataMobileComponent.prototype.onCreateNewModel = function () {
        this.salaryRecordItemHelper = new SalaryRecordItemHelper(this.salaryRecordModel, this.renderer, this.persistanceTypes, this.salaryTypes, this.settingService);
        this.salaryRecordItemHelper.updateSalaryType(this.salaryTypes[0]);
        PayrollCommon.assignEditableFields(this.salaryRecordModel, this.salaryTypes);
    };
    EmployeePayrollDataMobileComponent.prototype.onOpenCreateDialog = function () {
        this.flagUpdate = false;
        this.salaryRecordModel = {};
        this.updateDimensionValue();
        this.onCreateNewModel();
        this.isReloadBytype = false;
    };
    EmployeePayrollDataMobileComponent.prototype.onOpenUpdateDialog = function (model) {
        this.isUpdate = true;
        this.flagUpdate = true;
        this.salaryRecordModel = model;
        this.updateDimensionValue();
        PayrollCommon.assignEditableFields(this.salaryRecordModel, this.salaryTypes);
        this.isReloadBytype = false;
    };
    EmployeePayrollDataMobileComponent.prototype.oncloseInsertOrUpdatesalaryRecords = function () {
        this.isAddNew = false;
        this.isUpdate = false;
        this.salaryRecordModel = {};
        this.loadSalaryRecords();
        this.recalculate = true;
        this.isReloadBytype = false;
    };
    EmployeePayrollDataMobileComponent.prototype.onValueControlChange = function (model, feildChange) {
        var _this = this;
        if (feildChange === 'SalaryTypeId' && this.isReloadBytype === false) {
            this.isReloadBytype = true;
            return;
        }
        if (model) {
            if (feildChange === 'SalaryTypeId') {
                var salaryTypesTemp = this.salaryTypes.filter(function (item) { return item.SalaryTypeId === _this.salaryRecordModel.SalaryTypeId; });
                if (salaryTypesTemp && salaryTypesTemp[0]) {
                    this.isHaveNavigate = salaryTypesTemp[0].NegativeDefault;
                }
            }
            var modifiedField = {};
            modifiedField[feildChange] = model[feildChange];
            this.salaryRecordItemHelper = new SalaryRecordItemHelper(model, this.renderer, this.persistanceTypes, this.salaryTypes, this.settingService);
            var valid = this.salaryRecordItemHelper.validate(modifiedField);
            if (!valid) {
                this.isValidModel = false;
                return;
            }
            this.isValidModel = true;
            var previousDataItem = JSON.parse(JSON.stringify(model));
            this.salaryRecordItemHelper.updateRelavantFields(modifiedField);
            PayrollCommon.assignEditableFields(model, this.salaryTypes);
            var checkcheckAmountAutoFlip = PayrollCommon.checkAmountAutoFlip(previousDataItem, model);
            if (feildChange &&
                (modifiedField[feildChange] === 'AmountPerUnit' || modifiedField[feildChange] === 'Amount') &&
                checkcheckAmountAutoFlip) {
                // this.salaryRecordItemHelper.showInCellPopupMessage(model, "Amount", feildChange);
                this.showNegativeDefaulChange = true;
            }
            this.dataBlur = model;
            switch (feildChange) {
                case 'Amount':
                    this.feildBlur = 'Amount';
                    if (this.isHaveNavigate) {
                        this.showNegativeDefaulChange = true;
                    }
                    break;
                case 'AmountPerUnit':
                    this.feildBlur = 'AmountPerUnit';
                    if (this.isHaveNavigate) {
                        this.showNegativeDefaulChange = true;
                    }
                    break;
                default:
                    break;
            }
        }
    };
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isAutoFlipAmountsSetting", {
        get: function () {
            return PayrollCommon.isAutoFlipAmountsSetting();
        },
        enumerable: true,
        configurable: true
    });
    EmployeePayrollDataMobileComponent.prototype.onNegativeDefaultMoreInfoClick = function (fieldName) {
        this.negativeDefaultMoreDialogModel = {
            setting: this.isAutoFlipAmountsSetting,
            fieldName: fieldName,
            dataItem: this.salaryRecordModel
        };
        this.showNegativeDefaultMoreInfoDialog = true;
    };
    EmployeePayrollDataMobileComponent.prototype.onMoreInfoUsePositiveAmount = function (args) {
        this.usePositiveAmount(args.dataItem, args.fieldName);
    };
    EmployeePayrollDataMobileComponent.prototype.usePositiveAmount = function (dataItem, fieldName) {
        this.salaryRecordItemHelper.usePositiveAmount(fieldName);
        this.onValueControlChange(dataItem, '');
    };
    EmployeePayrollDataMobileComponent.prototype.autoCorrect = function (args) {
        this.salaryRecordItemHelper.autoCorrect(args.fieldName);
        this.onValueControlChange(args.dataItem, '');
    };
    EmployeePayrollDataMobileComponent.prototype.onNegativeDefaulChange = function (event) {
        if (event) {
            switch (event) {
                case 'MoreInfo':
                    this.onNegativeDefaultMoreInfoClick(this.feildBlur);
                    break;
                case 'UsePositiveAmountThisTime':
                    this.usePositiveAmount(this.dataBlur, this.feildBlur);
                    break;
                default:
                    break;
            }
        }
    };
    EmployeePayrollDataMobileComponent.prototype.CreateNewModel = function () {
        var _this = this;
        if (this.sessionService.isSubmitting) {
            return;
        }
        if (this.salaryRecordModel) {
            var salaryRecord = PayrollCommon.createSalaryRecord(this.salaryRecordModel, this.userEmployment.Id);
            this.dataService.SalaryRecords_CreateSalaryRecord(salaryRecord).subscribe(function (data) {
                _this.oncloseInsertOrUpdatesalaryRecords();
            }, function () {
                _this.oncloseInsertOrUpdatesalaryRecords();
            });
        }
    };
    EmployeePayrollDataMobileComponent.prototype.UpdateModel = function () {
        var _this = this;
        if (this.salaryRecordModel) {
            var salaryRecord = PayrollCommon.createSalaryRecord(this.salaryRecordModel, this.userEmployment.Id);
            this.dataService.SalaryRecords_UpdateSalaryRecord(salaryRecord).subscribe(function (data) {
                _this.oncloseInsertOrUpdatesalaryRecords();
            }, function () {
                _this.oncloseInsertOrUpdatesalaryRecords();
            });
        }
    };
    EmployeePayrollDataMobileComponent.prototype.onShowSelectPeriodDialog = function () {
        var _this = this;
        if (this.classShowSelectPeriodDialog) {
            this.classShowSelectPeriodDialog = '';
            setTimeout(function () {
                _this.classoverlayScreen = '';
                _this.isShowButtonPreview = true;
            }, 200);
            return;
        }
        this.classoverlayScreen = 'overlayScreen-enable';
        setTimeout(function () {
            _this.classShowSelectPeriodDialog = 'PreviewGridMobileEnable';
        });
        this.isShowButtonPreview = false;
    };
    EmployeePayrollDataMobileComponent.prototype.formatunit = function (unitstring) {
        if (unitstring) {
            // if (Global.SESSION.SignOnToken.Language.Code === 'EN') {
            //   return this.sessionService.toString(parseFloat(unitstring), '0.00').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            // }
            return this.sessionService.toString(parseFloat(unitstring), '0.00').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            // .replace(/.([^.]*)$/, ',$1');
        }
        return '';
    };
    EmployeePayrollDataMobileComponent.prototype.onClosePreviewArea = function () {
        this.classShowSelectPeriodDialog = '';
    };
    EmployeePayrollDataMobileComponent.prototype.DeleteModel = function () {
        var _this = this;
        if (this.salaryRecordModel && this.salaryRecordModel.Id) {
            this.dataService.SalaryRecords_DeleteSalaryRecord(this.salaryRecordModel.Id).subscribe(function () {
                _this.oncloseInsertOrUpdatesalaryRecords();
            }, function () {
                _this.oncloseInsertOrUpdatesalaryRecords();
            });
        }
    };
    Object.defineProperty(EmployeePayrollDataMobileComponent.prototype, "isHideUnitTypeControl", {
        get: function () {
            if (!this.salaryRecordModel.AllowEditUnitType &&
                (!this.salaryRecordModel.UnitTypeId ||
                    (this.salaryRecordModel.UnitTypeId && this.salaryRecordModel.UnitTypeId === -9999))) {
                return true;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    EmployeePayrollDataMobileComponent.prototype.onConfirmDeleteDialogAction = function (event) {
        if (event && event === 'Delete') {
            this.DeleteModel();
        }
    };
    EmployeePayrollDataMobileComponent.prototype.onAddNew = function () {
        var _this = this;
        if (this.sessionService.isSubmitting) {
            return;
        }
        setTimeout(function () {
            _this.fixedPanelService.calculateHeightContent();
        }, 500);
        this.isAddNew = true;
    };
    return EmployeePayrollDataMobileComponent;
}());
export { EmployeePayrollDataMobileComponent };
